import HomeContent from "@/pages/home/components/HomeContent";
import { AdvisorProvider } from "@/components/feature/AdvisorProvider";
import { advisors } from "@/mocks/advisors";

export default function KaterineMontoya() {
  return (
    <AdvisorProvider advisor={advisors["katerine-montoya"]}>
      <HomeContent />
    </AdvisorProvider>
  );
}